import {create} from 'zustand';

interface GuestStoreActions {
  reset: () => void;
}

type GuestStoreState =
  | {
      id: null;
      token: null;
    }
  | {
      id: string;
      token: string;
    };

type GuestStore = GuestStoreState & GuestStoreActions;

const initialState: GuestStoreState = {
  id: null,
  token: null,
};

export const useGuestStore = create<GuestStore>((set) => ({
  ...initialState,
  reset: () => set(initialState),
}));
